import {
  useMutation,
  type UseMutationResult,
  useQueryClient,
} from "@tanstack/react-query";
import { generateXlsx } from "@/api/endpoints/xlsx";
import { queryKeys } from "@/lib/queryClient";
import { InsufficientCreditsError } from "@/utils/supabaseFunctionsError";
import type {
  GenerateXlsxRequest,
  GenerateXlsxResponse,
} from "@/api/types/xlsx";

export function useGenerateXlsx(): UseMutationResult<
  GenerateXlsxResponse,
  Error,
  GenerateXlsxRequest,
  unknown
> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: generateXlsx,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.credits.balance(),
      });

      queryClient.invalidateQueries({
        queryKey: queryKeys.credits.all,
      });
    },
    onError: (error) => {
      if (error instanceof InsufficientCreditsError) {
        return;
      }
      console.error("📊 [XLSX] Failed to generate XLSX:", error);
    },
  });
}
